// Framework and third-party non-ui
import React, { useState } from 'react';

// App components
import OptionGroup from './OptionGroup';
import TrailLength from './TrailLength';

// Third-party components (buttons, icons, etc.)
import Button from '@material-ui/core/Button';
import Popover from '@material-ui/core/Popover';
import { makeStyles } from '@material-ui/core/styles';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import {activityTypeCodes, difficultyCodes, primaryTypeCodes, suitabilityTypeCodes} from './config.js';

// CSS
// import './FilterSelect.css';


const PopoverMenu = ({ type }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const useStyles = makeStyles((theme) => ({
    formControl: {
      marginRight: theme.spacing(1),
      backgroundColor: '#ffffff',
      borderRadius: '5px',
      color: '#4D4D4D',
      letterSpacing: '2px',
      '&:hover': {
        background: "#e6e6e6",
     },
     whiteSpace: 'nowrap'

    },
    chips: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    typography: {
        padding: theme.spacing(2),
      },
    root : {
      color: '#4D4D4D',
    },
    popoverPaper: {
      backgroundColor: '#ffffff'
    },
  }));

  const classes = useStyles();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <>

        {
          type === 'Difficulty' ? 
          ( 
            <>
            <Button aria-describedby={id} variant="contained" onClick={handleClick} className={classes.formControl}>
              {type} <KeyboardArrowDownIcon />
            </Button>
            <Popover
              id={id}
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
              }}
              transformOrigin={{
              vertical: 'top',
              horizontal: 'center',
              }}
              classes={{paper: classes.popoverPaper}}
              >
            <OptionGroup attributes={Object.keys(difficultyCodes)} 
                          optionType="Difficulty"
            />
            </Popover>
          </>) : null
        }

        {
          type === 'Activity Type' ? 
          ( 
            <>
            <Button aria-describedby={id} variant="contained" onClick={handleClick} className={classes.formControl}>
              {type} <KeyboardArrowDownIcon />
          </Button>
          <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
            }}
            transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
            }}
            classes={{paper: classes.popoverPaper}}
            >
            <OptionGroup attributes={Object.keys(activityTypeCodes)} 
                optionType="Activity Type"
            />
          </Popover>
          </>) : null
        }
                {
          type === 'Trail Type' ? 
          ( 
            <>
            <Button aria-describedby={id} variant="contained" onClick={handleClick} className={classes.formControl}>
            {type} <KeyboardArrowDownIcon />
          </Button>
          <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
            }}
            transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
            }}
            classes={{paper: classes.popoverPaper}}
            style={{height: '80vh'}}
            >
            <OptionGroup attributes={Object.keys(primaryTypeCodes)} 
                optionType="Primary Trail Type"
            />
          </Popover>
          </>) : null
        }
        {
          type === 'Length' ? 
          ( 
            <>
            <Button aria-describedby={id} variant="contained" onClick={handleClick} className={classes.formControl}>
            {type} <KeyboardArrowDownIcon />
          </Button>
          <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
            }}
            transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
            }}
            classes={{paper: classes.popoverPaper}}
            >
              <TrailLength />
          </Popover>
          </>) : null
        }
        {
          type === 'Suitability' ? 
          ( 
            <>
            <Button aria-describedby={id} variant="contained" onClick={handleClick} className={classes.formControl}>
            {type} <KeyboardArrowDownIcon />
          </Button>
          <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
            }}
            transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
            }}
            classes={{paper: classes.popoverPaper}}
            >
              <OptionGroup attributes={Object.keys(suitabilityTypeCodes)} 
              optionType="Suitability"
              />
          </Popover>
          </>) : null
        }
    </>
  );
};

export default PopoverMenu;
